import axios from "axios";
import { ChartBarleySoftWheat, DashboardLocIdInfo } from "./dashboardTypes";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../../configureStore";
import { API } from "../../../config";
import { setRowsPocketlabTable } from "../../slices/dashboard/dashboard";
import { getCurrentDayStart, getSelectedDayEnd } from "./dynamicCharts";

export const totalActionsWB = (WBActions: ChartBarleySoftWheat[]) => {
  return WBActions.reduce(
    (partialSum, actions) => partialSum + actions.actions,
    0
  );
};

export const addHours = (date: Date) => {
  const hoursToAdd = -2 * 60 * 60 * 1000;
  date.setTime(date.getTime() + hoursToAdd);
  return date;
};

export const addHoursSameTime = (date: Date) => {
  const hoursToAdd = 23.99 * 60 * 60 * 1000;
  date.setTime(date.getTime() + hoursToAdd);
  return date;
};

export const setZeroHrs = (date: Date) => {
  const tzoffset = new Date().getTimezoneOffset() * 60000;
  const zeroTime = new Date(date).setHours(0, 0, 0, 0);
  return new Date(zeroTime - tzoffset);
};

export const pocketLabDevicesChart = createAsyncThunk(
  "DashboardReducer/fetchActivityPocketLabDataDashboard2",
  async (arg: { token: string; id?: DashboardLocIdInfo[] }, store) => {
    const { locale } = (store.getState() as RootState).LayoutReducer;
    const { allLocations } = (store.getState() as RootState).DashboardReducer;
    const { dataDateActivity, locations } = (store.getState() as RootState)
      .DashboardFiltersReducer;

    const fromDate = getCurrentDayStart(dataDateActivity[0]);
    const toDate = getSelectedDayEnd(new Date(dataDateActivity[1]));

    const geoPointIds = locations.valuesSelected.map((loc) => loc.id);
    const geoPointParams = geoPointIds.map((id) => `id[$in][]=${id}`).join("&");

    const paramsAllLocations = [["appVersions", [fromDate, toDate]]];

    const params = paramsAllLocations
      .map((param) =>
        Array.isArray(param[1])
          ? param[1].map((value) => `${param[0]}[]=${value}`)
          : [`${param[0]}=${param[1]}`]
      )
      .flat()
      .join("&");

    if ((arg.id && arg.id?.length > 0) || allLocations) {
      try {
        const response = await axios.get(
          !allLocations
            ? `${API}/users/organization-geo-point?${geoPointParams}${params}`
            : `${API}/users/organization-geo-point?${params}&${geoPointParams}`,
          {
            headers: {
              Authorization: `Bearer ${arg.token}`,
              "Accept-Language": `${locale}`,
            },
          }
        );

        const appVersion = response?.data?.appVersions;

        const rowsPocketLabTable = appVersion.map(
          (rowToPocketLabTable: any) => ({
            id: `${Math.random()}`,
            username: rowToPocketLabTable.username,
            siteName: rowToPocketLabTable.siteName,
            version: rowToPocketLabTable.version,
            lastActionAt: rowToPocketLabTable.lastActionAt,
          })
        );

        store.dispatch(setRowsPocketlabTable(rowsPocketLabTable));
      } catch (error) {
        return store.rejectWithValue(error);
      }
    }
  }
);

export const getPocketLabRecentVersion = createAsyncThunk(
  "DashboardReducer/getPocketLabRecentVersion",
  async (token: string, store) => {
    const { locale } = (store.getState() as RootState).LayoutReducer;
    try {
      const response = await axios.get(
        `${API}/users/app-updates/pocket-lab-kotlin-v4`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": `${locale}`,
          },
        }
      );
      return store.fulfillWithValue(response.data.version);
    } catch (error) {
      return store.rejectWithValue(error);
    }
  }
);

export interface DataTranformedToCharts {
  date: string;
  count: number;
}
